<script setup lang="ts">
import {ref, defineEmits, watch} from 'vue';
import Alert from "@/components/ui/alerts/Alert.vue";
import Select from '../ui/select/Select.vue';

const emits = defineEmits<{
  (e: 'update:modelValue', selected: typeof noticeOptions[number]): void
}>();

const noticeOptions = [
  { label: 'Pas été prévenu de l’annulation', value: "NOT_NOTIFIED", eligible: true },
  { label: 'Moins de 7 jours avant le départ', value: "LESS_THAN_7_DAYS", eligible: true },
  { label: 'Entre 7 et 14 jours avant le départ', value: "BETWEEN_7_AND_14_DAYS", eligible: true },
  { label: 'Plus de 14 jours avant le départ', value: "MORE_THAN_14_DAYS", eligible: false },
];

const selected = ref(noticeOptions[0]);
watch(selected, () => emits("update:modelValue", selected.value));
</script>

<template>
  <div class="relative">
    <!-- <label for="email" class="block mt-4 text-sm font-medium leading-6 text-left text-gray-900">Date d'annulation</label> -->
    <Select
      label="Date de l'annulation"
      :options="noticeOptions"
      @update:model-value="(newSelected: any) => selected = newSelected"
    />

    <div v-if="selected.value === 'MORE_THAN_14_DAYS'" class="mt-6">
      <Alert
        type="info"
        title="Attention"
        message="L'annulation n'est pas éligible au règlement EU 261/2004 si la compagnie a notifié plus de 14 jours avant le départ."
        :with-border="false"
      />
    </div>
  </div>
</template>
